import { render, staticRenderFns } from "./InputSearch.vue?vue&type=template&id=523295c0&scoped=true&"
import script from "./InputSearch.vue?vue&type=script&lang=js&"
export * from "./InputSearch.vue?vue&type=script&lang=js&"
import style0 from "./InputSearch.vue?vue&type=style&index=0&id=523295c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523295c0",
  null
  
)

export default component.exports